import type { FunctionComponent } from 'react';
import { makeList } from '../../helpers';
import { NUMBER_OF_SEASONS_PER_YEAR, Plans } from '../constants';
import { annualPerks, seasonalPerks } from './constants';

type PerksListProps = {
  selected: string;
  showAdditionalPerks: boolean;
  annualPrice: string;
  seasonalPrice: string;
};

const PerksList: FunctionComponent<PerksListProps> = ({
  selected = Plans.SEASONAL,
  showAdditionalPerks = false,
  annualPrice,
  seasonalPrice,
}) => {
  const currentList =
    selected === Plans.SEASONAL
      ? makeList(seasonalPerks, [], showAdditionalPerks)
      : makeList(annualPerks, [], showAdditionalPerks);
  const annualPricePerSeason = parseFloat(annualPrice) / NUMBER_OF_SEASONS_PER_YEAR;
  const formattedAnnualPricePerSeason = `$${Math.floor(annualPricePerSeason * 100) / 100} `;

  return (
    <>
      <div className="list-title-container" data-testid="list-title-container">
        <h2>
          {selected === Plans.SEASONAL ? 'Seasonal ' : 'Annual '}
          Subscription
        </h2>
        <h4>
          {selected === Plans.SEASONAL ? `$${seasonalPrice} ` : formattedAnnualPricePerSeason}/ box
        </h4>
      </div>
      <div className="listContainer">
        <ul className="perks-list">
          {currentList.slice(0, Math.floor(currentList.length / 2)).map(({ label, check }) => (
            <li key={label} className="perk" data-testid="list-perk">
              <i className={`far ${check ? 'fa-check' : 'fa-times'}`} />
              {label}
            </li>
          ))}
        </ul>
        <ul className="perks-list">
          {currentList
            .slice(Math.floor(currentList.length / 2), currentList.length)
            .map(({ label, check }) => (
              <li key={label} className="perk" data-testid="list-perk">
                <i className={`far ${check ? 'fa-check' : 'fa-times'}`} />
                {label}
              </li>
            ))}
        </ul>
      </div>
    </>
  );
};

export default PerksList;
